// extracted by mini-css-extract-plugin
module.exports = {"text":"_2fa8c59e","image":"_c584af44","imageOverlay":"_44c25cbe","link":"_6912aa63","header":"_3efa5cdc","description":"_39746a05","cta":"_a2866495"};